// extracted by mini-css-extract-plugin
export var equalColumn = "_fq-0";